<template>
  <div-box>
    <wallet-head show_type="7" />
    <div-padding padding="3vw 4vw">

      <!-- <div class="msgbox htmlcontentbox" v-html="blurb.content"></div> -->

      <div v-if="getLang() == 'zh'" class="msgbox htmlcontentbox" v-html="blurb.content"></div>
      <div v-if="getLang() == 'en'" class="msgbox htmlcontentbox" v-html="blurb.content_en"></div>
      <div v-if="getLang() == 'tw'" class="msgbox htmlcontentbox" v-html="blurb.content_tw"></div>

    </div-padding>

  </div-box>
</template>
<script>
export default {
  data() {
    return {
      blurb: {},
    }
  },
  created() {
    this.get_blurb()
  },
  methods: {
    get_blurb() {
      this.$get({
        url: "/api/v1/article/getInfo?id=1",
        success: (res) => {
          console.log("获取文章详情", res.data);
          this.blurb = res.data;
        },
        fail: () => { },
      });
    },
  },
}
</script>
<style lang='less' scoped>
.indexbox {
  width: 100%;
  padding: 15px 15px 40px;

  .bodybox {
    width: 100%;
    background: #242424 !important;
    border-radius: 6px 6px 6px 6px;
    padding: 20px 10px;

    .tit {
      width: 100%;
      font-size: 4vw;
      font-weight: 550;
    }

    .time {
      width: 100%;
      padding: 10px 0;
      color: #999999;
      font-size: 12px;
    }

    .msgbox {
      width: 100%;
      color: #999999;
      font-size: 14px;
    }
  }
}
</style>